var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#C1C3C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4888,
    y: 4.60437,
    width: 1.28,
    height: 8.32,
    rx: 0.64,
    transform: "rotate(45 10.4888 4.60437)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.395,
    y: 10.4884,
    width: 1.28,
    height: 8.32,
    rx: 0.64,
    transform: "rotate(135 11.395 10.4884)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldClear);
export default __webpack_public_path__ + "static/media/field-clear.dc682603d4ba0b7b1096bf8c3fb44de6.svg";
export { ForwardRef as ReactComponent };